import http from '@/utils/http';
import httpApi from '@/apis/httpApi';

export const getRuleByBarId = (id) => {
  return http.get({
    url: httpApi.debugModel.getRuleByBarId,
    data: {
      id,
    },
  });
};
export const delRuleByBarId = ({ id, rules }) => {
  return http.get({
    url: httpApi.debugModel.delRuleByBarId,
    data: {
      id,
    },
  });
};
export const addRuleByBarId = ({ id, rules }) => {
  return http.get({
    url: httpApi.debugModel.addRuleByBarId,
    data: {
      id,
      rules,
    },
  });
};
export const updateRuleByBarId = ({ id, rules }) => {
  return http.get({
    url: httpApi.debugModel.updateRuleByBarId,
    data: {
      id,
      rules,
    },
  });
};

export const getDebugCfgByBarId = (id) => {
  return http.get({
    url: httpApi.debugModel.getDebugCfgByBarId,
    data: {
      id,
    },
  });
};
export const addDebugCfgByBarId = ({ id, cfg }) => {
  return http.get({
    url: httpApi.debugModel.addDebugCfgByBarId,
    data: {
      id,
      cfg,
    },
  });
};
export const delDebugCfgByBarId = ({ id, cfg }) => {
  return http.get({
    url: httpApi.debugModel.delDebugCfgByBarId,
    data: {
      id,
      cfg,
    },
  });
};
export const updateDebugCfgByBarId = ({ id, cfg }) => {
  return http.get({
    url: httpApi.debugModel.updateDebugCfgByBarId,
    data: {
      id,
      cfg,
    },
  });
};

export const onDebugCfgByBarId = ({ id }) => {
  return http.get({
    url: httpApi.debugModel.onDebugCfgByBarId,
    data: {
      id,
    },
  });
};
export const offDebugCfgByBarId = ({ id }) => {
  return http.get({
    url: httpApi.debugModel.offDebugCfgByBarId,
    data: {
      id,
    },
  });
};

export const updateDebugIpByBarId = (id, ip) => {
  return http.get({
    url: httpApi.debugModel.updateDebugIpByBarId,
    data: {
      id,
      ip,
    },
  });
};

export const setDebugRuleByRuleId = (barId, ruleId) => {
  return http.get({
    url: httpApi.debugModel.setDebugRuleByRuleId,
    data: {
      barId,
      ruleId,
    },
  });
};

export const delDebugRuleByRuleId = (barId, ruleId) => {
  return http.get({
    url: httpApi.debugModel.delDebugRuleByRuleId,
    data: {
      barId,
      ruleId,
    },
  });
};
export const addDebugRuleByBarId = (id, ruleId, rule) => {
  return http.post({
    url: httpApi.debugModel.addDebugRuleByBarId,
    json: {
      id,
      rules: {
        ruleId: ruleId,
        rule: rule,
        ipTail: '',
        os: '',
      },
    },
  });
};
export const searchBarList = (page, size, key) => {
  return http.get({
    url: httpApi.debugModel.searchBarList,
    data: {
      page,
      size,
      key,
    },
  });
};
export const getBarList = (page, size, key) => {
  return http.get({
    url: httpApi.debugModel.getBarList,
    data: {
      page,
      size,
      key,
    },
  });
};
export const updateDebugRuleByBarId = (id, ruleId, rule) => {
  return http.post({
    url: httpApi.debugModel.updateDebugRuleByBarId,
    json: {
      id,
      rules: {
        ruleId: ruleId,
        rule: rule,
        os: '',
        ipTail: '',
      },
    },
  });
};

export const getLogDirOfBar = (data) => {
  return http.get({
    url: httpApi.debugModel.getLogDirOfBar,
    data: data,
  });
};
export const getLogSearch = (data) => {
  return http.get({
    url: httpApi.debugModel.getLogSearch,
    data: data,
  });
};
export const getLogTitle = (data) => {
  return http.get({
    url: httpApi.debugModel.getLogTitle,
    data: data,
  });
};
export const getLogList = (data) => {
  return http.get({
    url: httpApi.debugModel.getLogList,
    data: data,
  });
};
export const getProcess = (data) => {
  return http.get({
    url: httpApi.debugModel.getProcess,
    data: data,
  });
};
export const queryClientOnline = (data) => {
  return http.get({
    url: httpApi.debugModel.queryClientOnline,
    data: data,
  });
};
